// Shared Pinia Colada query defaults. Imported by the app entry point and by
// the frontend test helper so test mounts exercise the same caching/refetch
// behaviour as production.
export const piniaColadaQueryDefaults = {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 15,
} as const;
